import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  ListItemText,
  ListSubheader,
  MenuItem,
  Select,
  Typography,
  Chip,
} from "@mui/material";
import { useState } from "react";
import { splitCamelCaseToWords } from "../../utils/Formatter";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface HeaderWithMultiSelectProps {
  headerName: string | undefined;
  showFilter: boolean;
  width?: number;
  values?: any;
  onFilterSubmit?: any;
}
export default function TableHeaderMultiSelectField({
  headerName,
  showFilter,
  width,
  values,
  onFilterSubmit,
}: HeaderWithMultiSelectProps) {
  const dropdownWidth = width && width - 20;
  const [selectedValue, setSelectedValue] = useState<string[]>([]);

  const onSelectChange = (event: any) => {
    const value = event.target.value;
    setSelectedValue(value);
    const filter: any = {
      certifications: [],
      insurances: [],
    };
    filter.backgroundCheckCompleted = value.includes("backgroundCheck")
      ? true
      : false;
    value.forEach((item: string) => {
      if (values.certificateTypes.includes(item)) {
        filter.certifications?.push(item);
      }
      if (values.insuranceTypes.includes(item)) {
        filter.insurances?.push(item);
      }
    });
    onFilterSubmit(filter);
  };

  return (
    <Box sx={{ width, pr: 1 }}>
      <Box className="header" sx={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ fontWeight: "bold" }}>{headerName}</Typography>
      </Box>

      <FormControl sx={{ display: showFilter ? "block" : "none", mt: 1 }}>
        <Select
          sx={{
            width: dropdownWidth,
            minHeight: "40px",
            "& .MuiSelect-select": {
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              maxHeight: "32px",
              overflow: "hidden",
            },
          }}
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          size="small"
          multiple
          value={selectedValue}
          onChange={onSelectChange}
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                maxHeight: "32px",
                overflow: "hidden",
                alignItems: "center",
              }}
            >
              {selected.length === 0 ? (
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", fontStyle: "italic" }}
                >
                  Select
                </Typography>
              ) : selected.length > 2 ? (
                <>
                  <Chip
                    label={selected[0]}
                    size="small"
                    sx={{ height: "20px", fontSize: "0.75rem" }}
                  />
                  <Chip
                    label={`+${selected.length - 1} more`}
                    size="small"
                    sx={{
                      height: "20px",
                      fontSize: "0.75rem",
                      backgroundColor: "primary.light",
                      color: "white",
                    }}
                  />
                </>
              ) : (
                selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    size="small"
                    sx={{ height: "20px", fontSize: "0.75rem" }}
                  />
                ))
              )}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          <MenuItem
            key="backgroundCheck"
            value={"backgroundCheck"}
            sx={{ alignItems: "flex-start" }}
          >
            <Checkbox
              sx={{ py: 0 }}
              checked={selectedValue?.includes("backgroundCheck")}
            />
            <ListItemText
              sx={{ textWrap: "wrap" }}
              primary={"Background Check Completed"}
            />
          </MenuItem>
          <Divider />
          <ListSubheader
            sx={{
              color: "rgba(0, 0, 0, 0.87)",
              fontWeight: "600",
              lineHeight: 2,
            }}
          >
            Certifications
          </ListSubheader>
          {values.certificateTypes?.map((value: any) => (
            <MenuItem key={value} value={value}>
              <Checkbox checked={selectedValue?.includes(value)} />
              <ListItemText primary={value && splitCamelCaseToWords(value)} />
            </MenuItem>
          ))}
          <Divider />
          <ListSubheader
            sx={{
              color: "rgba(0, 0, 0, 0.87)",
              fontWeight: "600",
              lineHeight: 2,
            }}
          >
            Insurance Required
          </ListSubheader>
          {values.insuranceTypes?.map((value: any) => (
            <MenuItem key={value} value={value}>
              <Checkbox checked={selectedValue?.includes(value)} />
              <ListItemText primary={value && splitCamelCaseToWords(value)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
